import 'webpack-jquery-ui';

function getProvinces(countryId) {
  $.ajax({
    url: `/provinces/${countryId}`,
    dataType: 'json',
  }).done((e) => {
    $('select#provincewrap').replaceWith(e);
    const phone = $('#provincewrap').attr('phone');
    $('#Phonenumber').val(phone);
  }).fail(() => {
    // eslint-disable-next-line no-alert
    alert('Results could not be loaded.');
  });
}

$(() => {
  const countrySelect = document.getElementById('country');
  countrySelect.addEventListener('change', () => {
    getProvinces(countrySelect.value);
  });

  const website = document.getElementById('website');

  website.addEventListener('change', () => {
    website.value = (website.value.indexOf('://') === -1) ? `https://${website.value}` : website.value;
  });

  const event = new Event('change');
  countrySelect.dispatchEvent(event);

  $('.companyname-autofill').autocomplete({
    source(request, response) {
      $.getJSON(`/company/${request.term}`).done((data) => {
        const parsedData = JSON.parse(data);
        if (typeof data !== 'undefined' && parsedData.length > 0) {
          const test = $.map(parsedData, (value) => ({
            label: value.companyname,
            value,
          }));
          const companies = [];
          $.each(parsedData, (value) => {
            companies.push(value.companyname);
          });
          response(test);
        }
      });
    },
    focus(event, ui) {
      $('#companyname').val(ui.item.value.companyname);
      $('#kvk').val(ui.item.value.chamberofcommerce);
      $('#street').val(ui.item.value.street);
      $('#number').val(ui.item.value.number);
      $('#Place').val(ui.item.value.place);
      return false;
    },
    select(event, ui) {
      $('#companyname').val(ui.item.value.companyname);
      $('#kvk').val(ui.item.value.chamberofcommerce);
      $('#street').val(ui.item.value.street);
      $('#number').val(ui.item.value.number);
      $('#Place').val(ui.item.value.place);
      $.getJSON(`/companydetail/${ui.item.value.link}`).done((data) => {
        const parsedData = JSON.parse(data);
        $('#Postcode').val(parsedData.postalcode);
        $('#website').val(parsedData.website);
        $('#province-selector > option').each(function selectProvince() {
          if ($(this).html().toLowerCase() === parsedData.region.toLowerCase()) {
            $(this).prop('selected', true);
          }
        });
      });
      return false;
    },
    minLength: 3,
    delay: 100,
  });
});
